<div class="dialog-content-wrapper">
  <mat-toolbar matDialogTitle class="mat-accent m-0">
    <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
      <span class="title dialog-title">{{dialogTitle | translate}}</span>
      <button mat-button class="mat-icon-button"
        (click)="dialogRef.close()"
        aria-label="Close dialog">
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>

  @if (formGroup) {
    <div mat-dialog-content class="p-24 m-0">
      <form [formGroup]="formGroup" class="canton-form add-user-form">
        @if (formGroup.get('duplicateAddress')?.enabled) {
          <mat-checkbox class="width-100" formControlName="duplicateAddress">{{'user.autofill' | translate}}</mat-checkbox>
        }
        @if (formGroup.get('frontRoleId')?.enabled) {
          <mat-form-field appearance="fill" class="width-100">
            <mat-label>{{ 'user.role' | translate }}</mat-label>
            <mat-select formControlName="frontRoleId" required>
              @for (role of roles; track role.value) {
                <mat-option [value]="role.value">
                  {{role.label}}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
        @if (formGroup.get('firstName')?.enabled) {
          <mat-form-field class="width-50">
            <mat-label>{{ 'user.firstName' | translate }}</mat-label>
            <input formControlName="firstName" matInput required>
          </mat-form-field>
        }
        @if (formGroup.get('lastName')?.enabled) {
          <mat-form-field class="width-50">
            <mat-label>{{ 'user.lastName' | translate }}</mat-label>
            <input formControlName="lastName" matInput required>
          </mat-form-field>
        }
        @if (formGroup.get('nickName')?.enabled) {
          <mat-form-field class="width-50">
            <mat-label>{{ 'user.nickName' | translate }}</mat-label>
            <input formControlName="nickName" matInput>
          </mat-form-field>
        }
        @if (formGroup.get('email')?.enabled) {
          <mat-form-field class="width-50">
            <mat-label>{{ 'user.email' | translate }}</mat-label>
            <input formControlName="email" matInput>
            @if (formGroup.get('email')?.hasError('checkEmailOnServer')) {
              <mat-error>
                {{'checkEmailOnServer' | translate}}
              </mat-error>
            }
          </mat-form-field>
        }
        @if (formGroup.get('countryId')?.enabled) {
          <mat-form-field appearance="fill" class="width-50">
            <mat-label>{{ 'user.country' | translate }}</mat-label>
            <mat-select formControlName="countryId" required>
              @for (country of countries; track country.id) {
                <mat-option [value]="country.id">
                  {{country.name}}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
        @if (formGroup.get('cityId')?.enabled) {
          <mat-form-field appearance="fill" class="width-50">
            <mat-label>{{ 'user.canton' | translate }}</mat-label>
            <mat-select formControlName="cityId" required>
              @for (city of cities; track city) {
                <mat-option [value]="city.id">
                  {{city.name}}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
        @if (formGroup.get('organizationId')?.enabled) {
          <mat-form-field appearance="fill" class="width-50">
            <mat-label>{{ 'user.organization' | translate }}</mat-label>
            <mat-select formControlName="organizationId" required>
              @for (org of organizations; track org.id) {
                <mat-option [value]="org.id">
                  {{org.name}}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
        @if (formGroup.get('lang')?.enabled) {
          <mat-form-field appearance="fill" class="width-50">
            <mat-label>{{'user.lang' | translate}}</mat-label>
            <mat-select formControlName="lang" required>
              @for (lang of languages; track lang) {
                <mat-option [value]="lang.value">
                  {{lang?.label}}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
        @if (formGroup.get('gender')?.enabled) {
          <mat-form-field appearance="fill" class="width-50">
            <mat-label>{{'user.gender' | translate}}</mat-label>
            <mat-select formControlName="gender" required>
              @for (gen of genders; track gen) {
                <mat-option [value]="gen.value">
                  {{gen?.label}}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
        @if (formGroup.get('genderType')?.enabled) {
          <mat-form-field appearance="fill" class="width-50">
            <mat-label>{{'gender_type_select' | translate}}</mat-label>
            <mat-select formControlName="genderType" required>
              @for (gen of genderTypes; track gen) {
                <mat-option [value]="gen.id">
                  {{gen?.name}}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
        @if (formGroup.get('street')?.enabled) {
          <mat-form-field class="width-50">
            <mat-label>{{ 'user.street' | translate }}</mat-label>
            <input formControlName="street" matInput>
          </mat-form-field>
        }
        @if (formGroup.get('number')?.enabled) {
          <mat-form-field class="width-50">
            <mat-label>{{ 'user.number' | translate }}</mat-label>
            <input formControlName="number" matInput>
          </mat-form-field>
        }
        @if (formGroup.get('postcode')?.enabled) {
          <mat-form-field class="width-50">
            <mat-label>{{ 'user.postcode' | translate }}</mat-label>
            <input formControlName="postcode" matInput>
          </mat-form-field>
        }
        @if (formGroup.get('cityLocation')?.enabled) {
          <mat-form-field class="width-50">
            <mat-label>{{ 'user.city' | translate }}</mat-label>
            <input formControlName="cityLocation" matInput>
          </mat-form-field>
        }
        @if (formGroup.get('phone')?.enabled) {
          <mat-form-field class="width-50">
            <mat-label>{{ 'user.phone' | translate }}</mat-label>
            <input formControlName="phone" matInput appPhoneMask>
          </mat-form-field>
        }
        @if (formGroup.get('mobile')?.enabled) {
          <mat-form-field class="width-50">
            <mat-label>{{ 'user.mobile' | translate }}</mat-label>
            <input formControlName="mobile" matInput appPhoneMask>
          </mat-form-field>
        }
        @if (formGroup.get('dateOfBirth')?.enabled) {
          <mat-form-field class="width-50">
            <input matInput [matDatepicker]="picker1" placeholder="{{'user.dateOf_birth' | translate}}"
              formControlName="dateOfBirth" readonly>
              <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
              <mat-datepicker #picker1 disabled="false"></mat-datepicker>
            </mat-form-field>
          }
          @if (formGroup.get('abschlussjahr')?.enabled) {
            <mat-form-field class="width-50">
              <mat-label>{{ 'user.abschlussjahr' | translate }}</mat-label>
              <input formControlName="abschlussjahr" matInput>
            </mat-form-field>
          }
          @if (formGroup.get('dateOfBaptism')?.enabled) {
            <mat-form-field class="width-50">
              <input matInput [matDatepicker]="picker" placeholder="{{'user.dateOfBaptism' | translate}}"
                formControlName="dateOfBaptism" disabled readonly>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker disabled="false"></mat-datepicker>
              </mat-form-field>
            }
            @if (formGroup.get('targetGroupId')?.enabled) {
              <mat-form-field appearance="fill" class="width-100">
                <mat-label>{{'user.targetGroup' | translate}}</mat-label>
                <mat-select formControlName="targetGroupId">
                  @for (tg of targetGroups; track tg) {
                    <mat-option [value]="tg.value">
                      {{tg?.label}}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            }
            @if (formGroup.get('representative')?.enabled) {
              <br>
              <mat-checkbox class="width-50" formControlName="representative">{{'representative' | translate}}</mat-checkbox>
            }
            @if (formGroup.get('status')?.enabled) {
              <mat-form-field appearance="fill" class="width-100">
                <mat-label>{{'user.status-level' | translate}}</mat-label>
                <mat-select formControlName="status" multiple>
                  @for (ls of levelStatuses; track ls) {
                    <mat-option [value]="ls.value">
                      {{ls?.label}}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            }
            @if (formGroup.get('confessionId')?.enabled) {
              <mat-form-field appearance="fill" class="width-50">
                <mat-label>{{'user.confession' | translate}}</mat-label>
                <mat-select formControlName="confessionId">
                  @for (cs of confessions; track cs) {
                    <mat-option [value]="cs.id">
                      {{cs?.name}}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            }
            @if (formGroup.get('notes')?.enabled) {
              <mat-form-field appearance="fill" class="width-100">
                <mat-label>{{ 'user.notes' | translate }}</mat-label>
                <textarea matInput cdkTextareaAutosize
                  #autosize="cdkTextareaAutosize"
                  cdkAutosizeMinRows="2"
                cdkAutosizeMaxRows="5" formControlName="notes"></textarea>
              </mat-form-field>
            }
          </form>
        </div>
      }

      <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign=" center">

        @if (action !=='edit' && !hideForm) {
          <button
            mat-raised-button
            (click)="saveUser([formGroup, 'save'])"
            class="save-button mat-accent"
            [disabled]="formGroup && formGroup.invalid"
            aria-label="SAVE" >
            {{'main.save' | translate}}
          </button>
        }

        @if (action ==='edit' && !hideForm) {
          <button
            mat-raised-button
            (click)="saveUser([formGroup, 'save'])"
            class="save-button mat-accent"
            [disabled]="formGroup && formGroup.invalid"
            aria-label="SAVE">
            {{'main.save' | translate}}
          </button>
        }
        @if (hideForm) {
          <button
            mat-raised-button
            (click)="saveUser([existUser, 'connect'])"
            class="save-button mat-accent"
            aria-label="SAVE"
            [disabled]="formGroup && formGroup.invalid">
            {{'main.save' | translate}}
          </button>
        }

        @if (hideForm) {
          <button
            mat-raised-button
            (click)="backForm()"
            class="save-button mat-accent"
            aria-label="SAVE">
            {{'frontUser.back' | translate }}
          </button>
        }



        <!--<button *ngIf="action ==='edit'"-->
        <!--mat-button-->
        <!--class="mat-icon-button"-->
        <!--(click)="dialogRef.close(['delete',formGroup])"-->
        <!--aria-label="Delete"-->
        <!--matTooltip="Delete">-->
        <!--<mat-icon>delete</mat-icon>-->
      <!--</button>-->

    </div>
  </div>
